import { personForsikringForm } from "../../../../../config/form/person/personForsikringerFormConfig";
import { getHeaderActiveColumns, TD } from "../../../../../util/table";
import { tableToXLSX } from "../../../../../util/tableExportUtils";
import ButtonDownload from "../../../../ButtonDownload";
import ActiveIcon from "../../../../icons/ActiveIcon";
import TableBasic, { TableRow } from "../../../../Table/TableBasic";
import IngenRegistreringer from "../IngenRegistreringer";
import OpretNyButtonBlock from "../OpretNyButtonBlock";
import { PersonForsikringField } from "../../../../../interfaces/personer";
import { IColumn, SortBy } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import { PersonForsikring } from "../../../../../interfaces/schema";
import { useGenericQuery } from "../../../../../hooks/useQueries";
import { useContext } from "react";
import { UserQueryContext } from "../../../../../context/UserContext";
import { periodeIsActive } from "../../../../../util/date";
import { orderBy } from "../../../../../util/orderBy";

export default function Forsikringer({
  columns,
  defaultColumns,
  personId,
  setActiveColumns,
  personForsikring,
  invalidateData,
  kundeNr,
}: {
  personId: string;
  kundeNr: number;
  personForsikring: PersonForsikring[];
  defaultColumns: IColumn<PersonForsikringField>[];
  columns: IColumn<PersonForsikringField>[];
  setActiveColumns: React.Dispatch<
    React.SetStateAction<PersonForsikringField[]>
  >;
  invalidateData: InvalidateDataFunction<any>;
}) {
  const { user, hasPermission } = useContext(UserQueryContext);
  const isAuth = hasPermission(user, "TilsynWrite");
  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "personForsikringerSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );
  const initialQueryValues =
    useGenericQuery<IForsikringsselskab>("forsikringsselskab");
  const queryValues = {
    ...initialQueryValues,
    data: initialQueryValues.data?.map((forsikring) => {
      return {
        ...forsikring,
        navn: forsikring.navn1,
      };
    }),
  };

  if (!personForsikring || personForsikring.length === 0) {
    return (
      <IngenRegistreringer
        editConfig={
          isAuth ? personForsikringForm(queryValues, personId) : undefined
        }
        invalidateData={invalidateData}
      />
    );
  }

  return (
    <>
      <ButtonDownload
        onClick={() =>
          tableToXLSX(columns, personForsikring, {
            fileName: `forsikringer-for-${kundeNr}`,
            additionalData: {
              kundenr: kundeNr,
            },
          })
        }
      />
      <TableBasic
        defaultColumns={defaultColumns}
        headerRow={
          <>
            <th></th>
            {getHeaderActiveColumns(columns, {
              defaultSortBy,
              setSortBy,
              sortBy,
            })}
          </>
        }
        columns={columns}
        setActiveColumns={setActiveColumns}
      >
        {orderBy(
          personForsikring,
          sortBy.map((s) => s.field),
          sortBy.map((s) => s.direction),
        ).map((forsikring) => {
          return (
            <TableRow
              key={forsikring.id}
              editConfig={
                isAuth
                  ? personForsikringForm(queryValues, personId, forsikring.id)
                  : undefined
              }
              invalidateData={invalidateData}
            >
              <td
                className={`indicator${
                  periodeIsActive(
                    new Date(forsikring.periode.fraDato),
                    new Date(forsikring.periode.tilDatoInklusiv),
                  )
                    ? " has-effect"
                    : ""
                }`}
              >
                <ActiveIcon />
              </td>
              <>
                {columns
                  .filter((col) => col.active)
                  .map((col) => {
                    return (
                      <TD key={col.field} col={col} rowData={forsikring} />
                    );
                  })}
              </>
            </TableRow>
          );
        })}
      </TableBasic>
      <OpretNyButtonBlock
        editConfig={
          isAuth ? personForsikringForm(queryValues, personId) : undefined
        }
        invalidateData={invalidateData}
      />
    </>
  );
}
const defaultSortBy: SortBy[] = [
  {
    direction: "desc",
    field: "periode.fraDato",
  },
  {
    direction: "desc",
    field: "periode.tilDatoInklusiv",
  },
];
